import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: 'input[type="number"]',
})
export class PreventInputScrollDirective {
  @HostListener("wheel", ["$event"])
  public onMouseWheel(event: WheelEvent) {
    if (event.target) {
      //@ts-ignore
      event.target.blur();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/prevent-input-scroll/prevent-input-scroll.directive.ts